module.exports = __webpack_public_path__ + "img/公司照片@2x.c63df90d.png";